"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundOffIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.fill2, fill2 = _c === void 0 ? 'black' : _c, size = _a.size, rest = __rest(_a, ["fill", "fill2", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M4.5 9C4.5 8.17157 5.17157 7.5 6 7.5H7.08774C7.81684 7.5 8.50961 7.18172 8.98456 6.62853L13.7974 1.02288C14.0823 0.690972 14.498 0.5 14.9354 0.5H16.0232C16.8516 0.5 17.5232 1.17157 17.5232 2V22C17.5232 22.8284 16.8516 23.5 16.0232 23.5H14.9354C14.498 23.5 14.0823 23.309 13.7974 22.9771L8.98456 17.3715C8.50961 16.8183 7.81684 16.5 7.08775 16.5H6C5.17157 16.5 4.5 15.8284 4.5 15V9Z", stroke: fill2, strokeWidth: "1", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M1 1L23 23", stroke: fill2, strokeWidth: "1", strokeLinecap: "round" }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.fill2, fill2 = _c === void 0 ? 'black' : _c, size = _a.size, rest = __rest(_a, ["fill", "fill2", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M6.08325 12C6.08325 10.9415 6.94137 10.0833 7.99992 10.0833H9.45025C10.4467 10.0833 11.3935 9.64834 12.0426 8.89232L18.4596 1.41813C18.8237 0.994018 19.3549 0.75 19.9138 0.75H21.3642C22.4227 0.75 23.2808 1.60812 23.2808 2.66667V29.3333C23.2808 30.3919 22.4227 31.25 21.3642 31.25H19.9138C19.3549 31.25 18.8237 31.006 18.4596 30.5819L12.0426 23.1077C11.3935 22.3517 10.4467 21.9167 9.45025 21.9167H7.99992C6.94137 21.9167 6.08325 21.0585 6.08325 20V12Z", stroke: fill2, strokeWidth: "1.5", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M1.33325 1.33333L30.6666 30.6667", stroke: fill2, strokeWidth: "1.5", strokeLinecap: "round" }, void 0)] }), void 0));
};
var SoundOffIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.SoundOffIcon = SoundOffIcon;
//# sourceMappingURL=SoundOffIcon.js.map